/**
 * Converts a UTC ISO time string to 12-hour display format in the given timezone.
 * e.g. "1970-01-01T07:19:00.000Z" + "America/Toronto" => "2:19 AM"
 */
export const formatTimeDisplay = (val, timezone) => {
  if (!val) return "-";
  try {
    return new Date(val).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: timezone || "UTC",
    });
  } catch {
    return "-";
  }
};

/**
 * Converts a UTC ISO time string to HH:mm (24-hour) in the given timezone.
 * Used to pre-fill <input type="time"> fields.
 * e.g. "1970-01-01T07:19:00.000Z" + "America/Toronto" => "03:19"
 */
export const formatTimeForInput = (val, timezone) => {
  if (!val) return "";
  try {
    return new Date(val).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: timezone || "UTC",
    });
  } catch {
    return "";
  }
};
